
import DateTimePicker from 'react-datetime-picker';
export default function DateTimeComponent(props) {

    return (
        <DateTimePicker className='surv-DateTime' onChange={props.handleChange} value={props.value} />
    )
}